import {Component, OnInit} from '@angular/core';
import {LangSrcService} from '../../../services/lang-src/lang-src.service';
import {ActivatedRoute, Router, RouterLink} from '@angular/router';
import {UserService} from '../../../services/user/user.service';
import {CommonModule} from '@angular/common';
import {TranslateModule} from '@ngx-translate/core';
import {SpinnerComponent} from '../../../components/spinner/spinner.component';

@Component({
  selector: 'app-evaluation-message',
  standalone: true,
  imports: [
    CommonModule,
    TranslateModule,
    RouterLink,
    SpinnerComponent
  ],
  templateUrl: './evaluation-message.component.html',
  styleUrls: ['./evaluation-message.component.scss']
})
export class EvaluationMessageComponent implements OnInit {

  loader = true;
  acceptConditions = false;
  level: any;

  constructor(
    private userSrv: UserService,
    public langSrcSrv: LangSrcService,
    public route: ActivatedRoute,
    private router: Router
  ) {
  }

  async ngOnInit() {
    this.level = await this.userSrv.currentLevel(this.route.snapshot.params.langTgt);
    this.loader = false;
  }

  async start() {
    await this.router.navigate([
      '/',
      this.langSrcSrv.current.shortCode,
      'evaluation',
      this.route.snapshot.params.langTgt,
      'questions'
    ]);
  }

  displayAcceptConditions() {
    return (
      this.level &&
      (this.level.position > 0 || this.level.playTime > 0)
    );
  }

}
